"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ExternalLink = function ExternalLink(props) {
  var children = props.children,
      className = props.className,
      href = props.href,
      title = props.title,
      restProps = _objectWithoutProperties(props, ["children", "className", "href", "title"]);

  return _react2.default.createElement(
    "a",
    _extends({
      className: (0, _classnames2.default)("erg-components-ExternalLink", "erg-link", className),
      href: href,
      rel: "noopener noreferrer",
      target: "_blank",
      title: title
    }, restProps),
    children
  );
};

ExternalLink.displayName = "ExternalLink";

ExternalLink.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  href: _propTypes2.default.string,
  title: _propTypes2.default.string
};

exports.default = ExternalLink;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/ExternalLink.js
 ** module id = 784
 ** module chunks = 0
 **/